// @flow
import PageNotFoundController from './PageNotFoundController'
import { withRouter } from 'react-router'
import { compose } from 'redux'

export default compose(
  withRouter
)(PageNotFoundController)
